import { render, staticRenderFns } from "./XhStructure.vue?vue&type=template&id=c5172782&scoped=true"
import script from "./XhStructure.vue?vue&type=script&lang=js"
export * from "./XhStructure.vue?vue&type=script&lang=js"
import style0 from "./XhStructure.vue?vue&type=style&index=0&id=c5172782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5172782",
  null
  
)

export default component.exports